import { useMemo } from "react";
import { DrivingSchool, OtherCalendarEventCategory } from "../providers/drivingSchoolsProvider";
import { useGetOne } from "react-admin";
import { useCurrentDrivingSchoolId } from "./useCurrentDrivingSchoolId";

export function useOtherEventCategories(): OtherCalendarEventCategory[] {
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const { data: drivingSchool } = useGetOne<DrivingSchool>("drivingSchools", { id: drivingSchoolId });
  return useMemo(
    () =>
      Object.entries(drivingSchool?.otherCalendarEventCategories ?? {}).map(([id, category]) => ({
        id,
        ...category,
      })),
    [drivingSchool?.otherCalendarEventCategories],
  );
}
